export default __webpack_public_path__ + "static/media/red-target.a58f2cb0.png";